export interface Category {
    label: string;
    value: string;
}

export const mapCategories = (categories: Record<string, string>): Category[] => {
    const uniqueCategories = new Map<string, string>();
    
    Object.entries(categories).forEach(([code, category]) => {
        const value = code.split('.')[0];
        if (!uniqueCategories.has(value)) {
            uniqueCategories.set(value, category);
        }
    });
    
    return Array.from(uniqueCategories, ([value, label]) => ({ label, value }))
        .sort((a, b) => a.label.localeCompare(b.label));
}
